<span class="font-weight-semibold align-self-center"> {{title}} </span>

<mat-form-field class=" mat-multi-select-with-footer mat-select-filters-dropdown  no-underline py-3" [formGroup]="customizeEventsForm" >
<mat-select panelClass="mat-multi-select-with-footer" #customize formControlName="custom_events_select" [ngModel] = "checkedEventsList" multiple  (valueChange) = "onEventsChangeFunction( $event )" (openedChange)="openCloseEventsChange($event)"  >
    <mat-select-trigger *ngIf="statusAll" style="color: #6f6f8d;">
      All
    </mat-select-trigger>
    <mat-select-trigger *ngIf="statusAll == false">
      {{getSelectedText(checkedEventsList[0])}} 
      <span *ngIf="checkedEventsList.length-1 > 0">
      (+{{checkedEventsList.length- 1}} others)
      </span>
    </mat-select-trigger>

    <!-- <mat-select-trigger>
      {{ moreFiltersForm.controls[item.filterStatusValField].value ? dropdownListMap[moreFiltersForm.controls[item.filterStatusValField].value[0]] : '' }}
      <span *ngIf="moreFiltersForm.controls[item.filterStatusValField].value?.length > 1" class="example-additional-selection">
        (+{{moreFiltersForm.controls[item.filterStatusValField].value.length - 1}} others)
      </span>
      </mat-select-trigger> -->


  <mat-option  *ngIf = "selectAllEnable" (click)="toggleAllSelection( $event )" value="all" class="border-bottom">All</mat-option>
  <mat-option *ngFor = "let item of AllEventsList" [value]="item.v" (click)="onEventsCheckboxClick( item.v )"> {{item.n}} </mat-option>
  <div class="mat-multi-select-footer text-right">
  <button type="button" class="btn btn-secondary mr-3" (click)="customize.close( )"> <span class="nxticon-close mr-2 font-extra-small"></span> Cancel </button>
  <button [class.disabled] = "hideEventsApply" (click)="customize.close( )" type="button" class="btn btn-primary " style="float: right;" (click)="applyEvents()"> <span class="nxticon-check-mark mr-2 font-extra-small"></span> Apply </button>
  </div>
</mat-select>
</mat-form-field>